import Link from 'next/link';

interface ReferenceCardProps {
  key: string;
  title: string;
  href: string;
  number: number;
}

function ReferenceCard({ title, href, number }: ReferenceCardProps) {
  return (
    <div className="grow mt-auto min-w-[290px] sm:grow-0 text-body text-left flex justify-start">
      <Link href={href}>
        <a>
          <span className="mr-1">{number}.</span>
          {title}
        </a>
      </Link>
    </div>
  );
}

const AllReferences: ReferenceCardProps[] = [
  {
    key: 'human-microbiome',
    number: 1,
    title:
      'Ursell, L. K., Metcalf, J. L., Parfrey, L. W., & Knight, R. (2012). Defining the human microbiome. Nutrition reviews, 70 Suppl 1(Suppl 1), S38–S44. https://doi.org/10.1111/j.1753-4887.2012.00493.x',
    href: 'https://doi.org/10.1111/j.1753-4887.2012.00493.x',
  },
  {
    key: 'childhood-prebiotic',
    number: 2,
    title:
      'Slattery, J., MacFabe, D. F., & Frye, R. E. (2016). The Significance of the Enteric Microbiome on the Development of Childhood Disease: A Review of Prebiotic and Probiotic Therapies in Disorders of Childhood. Clinical medicine insights. Pediatrics, 10, 91–107. https://doi.org/10.4137/CMPed.S38338',
    href: 'https://doi.org/10.4137/CMPed.S38338',
  },
  {
    key: 'teddy-stydy',
    number: 3,
    title:
      'Stewart, C.J., Ajami, N.J., O’Brien, J.L. et al. Temporal development of the gut microbiome in early childhood from the TEDDY study. Nature 562, 583–588 (2018). https://doi.org/10.1038/s41586-018-0617-x',
    href: 'https://doi.org/10.1038/s41586-018-0617-x',
  },
  {
    key: 'effect-of-diet',
    number: 4,
    title:
      'Leeming, E. R., Johnson, A. J., Spector, T. D., & Le Roy, C. I. (2019). Effect of Diet on the Gut Microbiota: Rethinking Intervention Duration. Nutrients, 11(12), 2862. https://doi.org/10.3390/nu11122862',
    href: 'https://doi.org/10.3390/nu11122862',
  },
  {
    key: 'biofilms-microbiome',
    number: 5,
    title:
      'Granger, CL, Embleton, ND, Palmer, JM, Lamb, CA, Berrington, JE, Stewart, CJ. Maternal breastmilk, infant gut microbiome and the impact on preterm infant health. Acta Paediatr. 2021; 110: 450– 457. https://doi.org/10.1111/apa.15534',
    href: 'https://doi.org/10.1111/apa.15534',
  },
  {
    key: 'gut-microbiome',
    number: 6,
    title:
      'Amir, A., Erez-Granat, O., Braun, T. et al. Gut microbiome development in early childhood is affected by day care attendance. npj Biofilms Microbiomes 8, 2 (2022). https://doi.org/10.1038/s41522-021-00265-w',
    href: 'https://doi.org/10.1038/s41522-021-00265-w',
  },
];

export function ReferencesSectionScience() {
  return (
    <section id="references-section-science">
      <div className="container flex flex-col gap-3">
        <h2 className="mb-3">References</h2>
        <>
          {AllReferences.map((reference) => (
            <div className="flex grow" key={reference.key}>
              <ReferenceCard {...reference} />
            </div>
          ))}
        </>
      </div>
    </section>
  );
}
